module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTMiIGZpbGw9IiNGRjYxNTMiLz4KPHBhdGggZD0iTTEwIDE1LjhMMTQuMTM1MyAxOS42NTk2QzE0LjMzNjggMTkuODQ3NyAxNC42NTI2IDE5LjgzNzIgMTQuODQxMiAxOS42MzZMMjIgMTIiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/featured/assets/al-approved-icon.svg
// module id = 6447
// module chunks = 25